module.exports = __webpack_public_path__ + "static/media/default_product.c849345b.png";